import styled from "styled-components";
import Icon from "../Icon/Icon";

const CARD_FORM_SECTION_GAP = "53px";
const FIELD_GAP = "12px";
const SECTION_CONTENT_GAP = "10px";

export const CardForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${CARD_FORM_SECTION_GAP};
`;

export const CardSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SECTION_CONTENT_GAP};
`;

export const CardSectionFields = styled.div<{
  $topSpacing?: "default" | "section";
}>`
  display: flex;
  flex-direction: column;
  gap: ${SECTION_CONTENT_GAP};
  margin-top: ${({ $topSpacing }) =>
    $topSpacing === "section" ? CARD_FORM_SECTION_GAP : "0"};
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${FIELD_GAP};
`;

export const AddressSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${FIELD_GAP};
`;

export const SectionTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.35;
  color: ${({ theme }) => theme.black};
`;

export const SplitFields = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 0.84fr);
  gap: 12px;

  ${({ theme }) => theme.xs`
    grid-template-columns: 1fr;
  `}
`;

export const AddressTripleFields = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 0.9fr) minmax(0, 0.9fr);
  gap: 12px;

  ${({ theme }) => theme.xs`
    grid-template-columns: 1fr;
  `}
`;

export const InputAdornment = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

export const BrandAdornment = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 20px;
`;

export const BrandLogo = styled.img`
  display: block;
  width: 32px;
  height: 20px;
  object-fit: contain;
`;

export const AdornmentButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
`;

export const AdornmentIcon = styled(Icon)`
  width: 20px;
  height: 20px;
  background-color: ${({ theme }) => theme.overlayMedium};
`;

export const TooltipContent = styled.div`
  max-width: 260px;
  line-height: 1.4;
`;

export const SecureNotice = styled.div`
  color: ${({ theme }) => theme.black50};
  font-size: 13px;
  line-height: 1.4;
`;
